import { render, staticRenderFns } from "./ObjHome.vue?vue&type=template&id=e62b8e12"
import script from "./ObjHome.vue?vue&type=script&lang=js"
export * from "./ObjHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports